export const LOAD_INIT = 'detailText/LOAD_INIT';
export const LOAD_SUCCESS = 'detailText/LOAD_SUCCESS';
export const LOAD_FAIL = 'detailText/LOAD_FAIL';

const ENDPOINT = '/api/detailText';

const initialState = {
  payload: null,        // the doc object with `.text`
  loading: false,
  error: null,
  offerType: null,
  filter: null
};

export default function detailText(state = initialState, action) {
  const type = action.type;

  if (type === LOAD_INIT) {
    const meta = action.meta || {};
    return {
      ...state,
      loading: true,
      error: null,
      offerType: typeof meta.offerType !== 'undefined' ? meta.offerType : state.offerType,
      filter: typeof meta.filter !== 'undefined' ? meta.filter : state.filter
    };
  }

  if (type === LOAD_SUCCESS) {
    const carrier = action.payload || action.result || action.response || null;

    const data =
      (carrier && carrier.data) ||
      (carrier && carrier.body) ||
      carrier;

    const doc =
      (data && data.detailText) ? data.detailText :
      (data && data.text) ? data :
      null;

    return {
      ...state,
      loading: false,
      error: null,
      payload: doc
    };
  }

  if (type === LOAD_FAIL) {
    return {
      ...state,
      loading: false,
      error: action.error || true
    };
  }

  return state;
}

/**
 * Fetch detail text by offerType + filter (matches /api/detailText/:offerType/:filter)
 */
export function getDetailText(offerType, filter) {
  const encType = encodeURIComponent(offerType || '');
  const encFilter = encodeURIComponent(filter || '');

  return {
    types: [LOAD_INIT, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${ENDPOINT}/${encType}/${encFilter}`),
    meta: { offerType, filter }
  };
}

export const selectDetailDoc = state =>
  state && state.detailText ? state.detailText.payload : null;
